import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "input"]

  connect() {
    const that = this;
    this.originalInput = this.inputTarget;
    document.onpaste = function(event){
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      Array.from(items).forEach((item) => {
        if (item.kind === 'file') {
          let selectedFile = document.createElement("div");
          selectedFile.className = "selected-file";
          let fileInput = that.originalInput.cloneNode();
          let file = item.getAsFile();
          let dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;
          selectedFile.append(fileInput);

          if(file['type'].split('/')[0] === 'image'){
            let reader = new FileReader();
            let image = document.createElement("img");
            image.className = "file-image";

            reader.onload = function () {
              image.src = reader.result;
            }

            reader.readAsDataURL(file);

            selectedFile.append(image);
          } else {
            let icon = document.createElement("div");
            icon.className = "file-icon";
            icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" aria-hidden="true" data-slot="icon" class="size-12">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"></path>
            </svg>`;

            selectedFile.append(icon);
          }

          let labelNode = document.createElement("label");
          labelNode.classList.add("break-all");
          let textElement = document.createTextNode(file.name);
          labelNode.appendChild(textElement);
          selectedFile.appendChild(labelNode);

          let deleteNode = document.createElement("a");
          deleteNode.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
          </svg>`;
          deleteNode.classList.add("remove-file");
          deleteNode.dataset.action = "click->multi-upload#remove";
          deleteNode.title = "Удалить файл";
          selectedFile.appendChild(deleteNode);

          that.fileTarget.append(selectedFile);
        }
      })
      that.originalInput.value = "";
    }
  }

  addFile(event) {
    Array.from(this.originalInput.files).forEach((file) => {
      let selectedFile = document.createElement("div");
      selectedFile.className = "selected-file";
      let dt = new DataTransfer();
      let fileInput = this.originalInput.cloneNode();
      dt.items.add(file);
      fileInput.files = dt.files;
      selectedFile.append(fileInput);

      if(file['type'].split('/')[0] === 'image'){
        let reader = new FileReader();
        let image = document.createElement("img");
        image.className = "file-image";

        reader.onload = function () {
          image.src = reader.result;
        }

        reader.readAsDataURL(file);

        selectedFile.append(image);
      } else {
        let icon = document.createElement("div");
        icon.className = "file-icon";
        icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" aria-hidden="true" data-slot="icon" class="size-12">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"></path>
        </svg>`;

        selectedFile.append(icon);
      }

      let labelNode = document.createElement("label");
      labelNode.classList.add("break-all");
      let textElement = document.createTextNode(file.name);
      labelNode.appendChild(textElement);
      selectedFile.appendChild(labelNode);

      let deleteNode = document.createElement("a");
      deleteNode.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
      </svg>`;
      deleteNode.classList.add("remove-file");
      deleteNode.dataset.action = "click->multi-upload#remove";
      deleteNode.title = "Удалить файл";
      selectedFile.appendChild(deleteNode);

      this.fileTarget.append(selectedFile);
      console.log(this.fileTarget)
      console.log(event.target)
    });

    this.originalInput.value = "";
  }

  remove(event){
    event.target.closest(".selected-file").remove();
  }
}